import { ReactComponent as MessageAddIcon } from 'assets/icons/email/message-add.svg';

export const email = {
  'message-add': MessageAddIcon,
};
